(function () {
  'use strict';

  var SECTION_SUFFIX = '__image_with_text_nk6LcN';
  var STEPS = [1, 1.5, 2, 3, 4];
  var MAX_SCALE = STEPS[STEPS.length - 1];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var dialog = document.getElementById('welcome-zoom-dialog');
    if (!dialog) return;
    var dialogImg = dialog.querySelector('.wz-dialog-img');
    var viewport = dialog.querySelector('.wz-viewport');
    var counter = dialog.querySelector('.wz-counter');
    var closeBtn = dialog.querySelector('.wz-close');
    var zoomInBtn = dialog.querySelector('.wz-in');
    var zoomOutBtn = dialog.querySelector('.wz-out');
    var resetBtn = dialog.querySelector('.wz-reset');

    var scale = 1;
    var panX = 0;
    var panY = 0;
    var lastFocus = null;

    function apply() {
      dialogImg.style.transform =
        'translate(' + panX + 'px,' + panY + 'px) scale(' + scale + ')';
      counter.textContent = Math.round(scale * 100) + '%';
      zoomOutBtn.disabled = scale <= STEPS[0];
      zoomInBtn.disabled = scale >= MAX_SCALE;
    }

    function reset() {
      scale = 1;
      panX = 0;
      panY = 0;
      apply();
    }

    function nearestIndex(value) {
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < STEPS.length; i++) {
        var d = Math.abs(STEPS[i] - value);
        if (d < bestDist) {
          bestDist = d;
          best = i;
        }
      }
      return best;
    }

    function stepZoom(dir) {
      var i = nearestIndex(scale);
      i = Math.min(STEPS.length - 1, Math.max(0, i + dir));
      scale = STEPS[i];
      if (scale === 1) {
        panX = 0;
        panY = 0;
      }
      apply();
    }

    // Hochaufloesende Variante der aktuell gerenderten Bildquelle
    function hiResSrc(img) {
      var src = img.currentSrc || img.src;
      if (!src) return '';
      var out = src.replace(/([?&])width=\d+/, '$1width=2560');
      if (out === src) {
        out += (src.indexOf('?') === -1 ? '?width=2560' : '&width=2560');
      }
      return out;
    }

    function openFrom(img) {
      var src = hiResSrc(img);
      if (!src) return;
      dialogImg.src = src;
      dialogImg.alt = img.alt || 'Begrüßungsbild vergrößert';
      reset();
      lastFocus = document.activeElement;
      dialog.showModal();
      closeBtn.focus();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    // Klick schliesst nur ohne vorherige Drag-Bewegung (sonst schliesst Pan -> Loslassen)
    var dragMoved = false;

    closeBtn.addEventListener('click', close);
    zoomInBtn.addEventListener('click', function () { stepZoom(1); });
    zoomOutBtn.addEventListener('click', function () { stepZoom(-1); });
    resetBtn.addEventListener('click', reset);

    dialog.addEventListener('click', function (e) {
      if (dragMoved) return;
      if (e.target === dialog || e.target === viewport) close();
    });
    dialog.addEventListener('close', function () {
      reset();
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === '+' || e.key === '=') {
        e.preventDefault();
        stepZoom(1);
      } else if (e.key === '-') {
        e.preventDefault();
        stepZoom(-1);
      } else if (e.key === '0') {
        e.preventDefault();
        reset();
      }
    });

    viewport.addEventListener('wheel', function (e) {
      e.preventDefault();
      stepZoom(e.deltaY < 0 ? 1 : -1);
    }, { passive: false });

    // Pan (Maus/1 Finger) und Pinch (2 Finger) ueber Pointer Events
    var pointers = new Map();
    var startDist = 0;
    var startScale = 1;
    var panStart = null;
    var downX = 0;
    var downY = 0;

    viewport.addEventListener('pointerdown', function (e) {
      viewport.setPointerCapture(e.pointerId);
      dragMoved = false;
      downX = e.clientX;
      downY = e.clientY;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1) {
        panStart = { x: e.clientX - panX, y: e.clientY - panY };
      } else if (pointers.size === 2) {
        var pts = Array.from(pointers.values());
        startDist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        startScale = scale;
        panStart = null;
      }
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 2) {
        var pts = Array.from(pointers.values());
        var dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        if (startDist > 0) {
          scale = Math.min(MAX_SCALE, Math.max(1, startScale * (dist / startDist)));
          if (scale === 1) {
            panX = 0;
            panY = 0;
          }
          apply();
        }
      } else if (pointers.size === 1 && panStart) {
        if (Math.abs(e.clientX - downX) > 6 || Math.abs(e.clientY - downY) > 6) dragMoved = true;
        panX = e.clientX - panStart.x;
        panY = e.clientY - panStart.y;
        apply();
      }
    });

    function endPointer(e) {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) startDist = 0;
      if (pointers.size === 0) panStart = null;
    }
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);

    var BTN_SVG =
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false">' +
      '<circle cx="11" cy="11" r="7"></circle>' +
      '<line x1="21" y1="21" x2="16.5" y2="16.5"></line>' +
      '<line x1="8" y1="11" x2="14" y2="11"></line>' +
      '<line x1="11" y1="8" x2="11" y2="14"></line></svg>';

    function bindSection(section) {
      if (!section || section.dataset.wzBound === '1') return;
      var media = section.querySelector('.image-with-text__media');
      var img = media && media.querySelector('img');
      if (!media || !img) return;
      section.dataset.wzBound = '1';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'wz-zoom-btn';
      btn.setAttribute('aria-label', 'Begrüßungsbild vergrößern');
      btn.innerHTML = BTN_SVG;
      media.appendChild(btn);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        openFrom(img);
      });
      img.addEventListener('click', function () {
        openFrom(img);
      });
    }

    function bindAll() {
      document
        .querySelectorAll('.shopify-section[id$="' + SECTION_SUFFIX + '"]')
        .forEach(bindSection);
    }

    bindAll();

    // Theme-Editor ersetzt Sektionen dynamisch -> erneut binden
    var observer = new MutationObserver(function () {
      bindAll();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
